




import Vue from 'vue';
import Component from 'vue-class-component';
import {verifyAd} from '@/clients/UserAdsClient';
import {VueGtag} from 'vue-gtag';
import {ControlParams, CustomParams, EventParams} from 'vue-gtag2';

@Component
export default class VerifyAdForm extends Vue {
  created() {
    const externalId = this.$route.params['externalId'];
    const auth = this.$route.params['auth'];

    let success = false;
    verifyAd(externalId, auth).then(response => {
      if (response.ok) {
        success = true;
        this.$bvModal.msgBoxOk(
          'Zgłoszenie oczekuje akceptacji moderatora i wkrótce pojawi się na stronie.',
          {title: 'Zgłoszenie zweryfikowane'},
        );
      } else {
        this.$bvModal.msgBoxOk('Coś poszło nie tak: ' + response.statusText);
      }
    }).catch(err => {
      this.$bvModal.msgBoxOk('Coś poszło nie tak: ' + err);
    }).finally(() => {
      this.trackVerifyEvent({success});
    });
  }

  private trackVerifyEvent(eventParams: ControlParams | EventParams | CustomParams): void {
    if (process.env.NODE_ENV === 'production') {
      (this.$gtag as VueGtag).event('verify', eventParams);
    }
  }
}
